import React from 'react';
import * as yup from 'yup';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ConnectFormikToStepper } from 'hellospa/components/prep-and-send/formik-utils';
import { haveFilesConverted } from 'hellospa/page/prep-and-send/data/selectors';
import { nextPageInWorkflow } from 'hellospa/page/prep-and-send/data/actions';
import * as types from 'hellospa/page/prep-and-send/data/types';
import loadingImage from 'images/v2/common/loader_@2x.gif';
import styles from './styles.scss';

const initialValues = {
  placeholderVal: null,
};

const schema = yup.object({
  placeholderVal: yup.boolean(),
});

const EmbeddedPreLoading: types.WorkflowComponent = ({ formRef }) => {
  const dispatch = useDispatch();
  // check if all files have been converted
  const allFilesConverted = useSelector(haveFilesConverted);

  React.useEffect(() => {
    if (allFilesConverted) {
      // move to the next page if all files are converted
      dispatch(nextPageInWorkflow());
    }
  }, [dispatch, allFilesConverted]);

  const imageStyle = {
    margin: 'auto',
    display: 'block',
  };

  return (
    <div className={styles.loadingContainer}>
      <Formik
        initialValues={initialValues}
        onSubmit={() => { }}
        validateOnChange={false}
        validationSchema={schema}
        validateOnMount={true}
        enableReinitialize={true}
        innerRef={types.useFormikRef(formRef)}
        // eslint-disable-next-line react/no-children-prop
        children={() => (
          <Form>
            <ConnectFormikToStepper />
            <FormattedMessage
              id=""
              description="loading message for embedded when documents are being converted"
              defaultMessage="We're preparing your documents" />
            <img style={imageStyle} src={loadingImage} />
          </Form>
        )} />
    </div>
  );
};

EmbeddedPreLoading.getText = () => ({});

export default EmbeddedPreLoading;
